export default "Escape Attic åbnede i juni 2018.";